<template>
    <div class="draggable row">
        <div class="col-sm-auto controls">
            <span class="drag-handle"><fa-icon icon="grip-lines"></fa-icon></span>
            <span class="index">{{index < 9 ? 0 : ''}}{{index + 1}}</span>
        </div>
        <div class="col-sm-auto controls order-12">
            <fa-icon icon="trash-alt" class="clickable" v-on:click="$emit('delete-message', index)"></fa-icon>
        </div>
        <message-cell
            v-for="cell in cells"
            :message="message"
            :position="cell"
            :attrs="attrs"
            :key="cell"
            :snickId="snickId"
            v-on:toggle-emoji-picker="$emit('toggle-emoji-picker', addMessageIndex($event))"
            v-on:toggle-fullscreen-message="$emit('toggle-fullscreen-message', $event)"
            v-on:image-loaded="$emit('image-loaded', $event)"
            v-on:input="$emit('input', $event)"
            v-on:change-position="$emit('change-position', $event)"
            v-on:change-character="$emit('change-character', $event)"
            ref="cell"
        />
    </div>
</template>

<script>
    import MessageCell from './MessageCell';

    export default {
        props: ['message', 'index', 'snickId' ],
        components: {
            MessageCell,
        },
        methods: {
            addMessageIndex(data) {
                data.index = this.index;
                return data;
            },
            insertEmoji: function(emoji) {
                const index = this.cells.findIndex((cell) => cell === this._props.message.msgPosition);
                this.$refs.cell[index].insertEmoji(emoji);
            }
        },
        data: function() {
            return {
                cells: [ 'left', 'center', 'right' ],
            };
        },
        computed: {
            attrs: function() {
                return {
                    position: this._props.message.msgPosition,
                    hasImage: this._props.message.image ? true : false,
                }
            }
        }
    };

</script>
